import type { OrderPrintLogView } from '../../../../../services/orders/orders.service';

export type PrintLogFilter = 'all' | 'printed' | 'skipped' | 'failed';
export type PrintLogTone = Exclude<PrintLogFilter, 'all'> | 'queued';

export function getKindLabel(kind: OrderPrintLogView['kind']): string {
  if (kind === 'receipt_print') return 'הדפסת חשבון';
  if (kind === 'red_fire') return 'RED – דילוג';
  if (kind === 'reprint') return 'הדפסה חוזרת';
  return 'הזמנה';
}

// A RED skip is stored as 'printed' since the skip itself fired; display it as skipped.
export function getLogTone(log: OrderPrintLogView): PrintLogTone {
  if (log.status === 'failed') return 'failed';
  if (log.status === 'queued') return 'queued';
  return log.kind === 'red_fire' ? 'skipped' : 'printed';
}

export function getStatusLabel(log: OrderPrintLogView): string {
  const tone = getLogTone(log);
  if (tone === 'failed') return 'נכשל';
  if (tone === 'queued') return 'ממתין';
  if (tone === 'skipped') return 'דולג';
  return log.kind === 'reprint' ? 'שליחה חוזרת' : 'הודפס';
}

export function getItemsLabel(count: number): string {
  return count === 1 ? 'פריט אחד' : `${count} פריטים`;
}

const DATE_FORMAT = new Intl.DateTimeFormat('he-IL', { day: '2-digit', month: '2-digit' });
const TIME_FORMAT = new Intl.DateTimeFormat('he-IL', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

export function formatLogDateTime(value: string | null): { date: string; time: string } {
  if (!value) return { date: '', time: '–' };
  const occurredAt = new Date(value);
  return { date: DATE_FORMAT.format(occurredAt), time: TIME_FORMAT.format(occurredAt) };
}
